import { render, staticRenderFns } from "./ExamProgram.vue?vue&type=template&id=6e54dc55&scoped=true&"
import script from "./ExamProgram.vue?vue&type=script&lang=js&"
export * from "./ExamProgram.vue?vue&type=script&lang=js&"
import style0 from "./ExamProgram.vue?vue&type=style&index=0&id=6e54dc55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54dc55",
  null
  
)

export default component.exports